import { Input } from 'antd'
import styled, { css } from 'styled-components/macro'
import { shake } from 'styles/global'
import { ITheme } from 'styles/types'

const { TextArea } = Input

const AutoGrowTextArea = styled(TextArea)<{
  $textColor: string
  $textColorFocused: string
  hasError?: boolean
}>`
  &&& {
    border: none;
    border-radius: 8px;
    font-size: 23px;
    padding: 0px 10px;
    height: 36px;
    font-family: 'Calibri';
    color: ${({ $textColor }) => $textColor};
    background: ${({ hasError, theme }) =>
      hasError ? theme.palette.error : 'rgba(255, 255, 255, 0.1)'};
    animation: ${({ hasError }) =>
      hasError
        ? css`
            ${shake} 0.6s linear
          `
        : ''};
    :focus {
      background: ${({ hasError, theme }) => (hasError ? theme.palette.error : '#fff')};
      color: ${({ $textColorFocused, hasError }) => (hasError ? '#fff' : $textColorFocused)};
    }
    text-align: left;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-weight: 700;

    @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.sm} {
      font-size: 19px;
      height: 32px;
    }
  }
`

export default AutoGrowTextArea
